export default __webpack_public_path__ + "static/media/VTorpedoClosed.f32b47a8.jpg";